import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const Reports = lazy(() => import("../components/Reports/ParentReportView.jsx"));
const Error404 = lazy(() => import("../pages/Errors/Error404.jsx"));
const Settings = lazy(() => import("../components/Settings/ParentSetting.jsx"));
const DomainRenewal = lazy(() => import("../components/DomainRenewal/DomainRenewal.jsx"));
const DomainManagement = lazy(() => import("../components/DomainManagement/ParentDomainManagement.jsx"));
const DomainDetailView = lazy(() => import("../components/DomainManagement/DomainDetailView.jsx"));

export default [
  { path: ROUTES.REPORTS, element: <LazyRoute><Reports /></LazyRoute> },
  { path: ROUTES.SETTINGS, element: <LazyRoute><Settings /></LazyRoute> },
  { path: ROUTES.DOMAIN_RENEWAL, element: <LazyRoute><DomainRenewal /></LazyRoute> },
  { path: ROUTES.ORDERS.DOMAIN_MANAGEMENT, element: <LazyRoute><DomainManagement /></LazyRoute> },
  { path: ROUTES.ORDERS.DOMAIN_DETAIL, element: <LazyRoute><DomainDetailView /></LazyRoute> },
  // Catch-all route for 404
  { path: "*", element: <LazyRoute><Error404 /></LazyRoute> },
];
